<div class="card panel-flat-color" [ngClass]="panelClass">
    <div class="panel-flat-header">
        <div class="float-start">
            @if (panelIconClass) {
                <div class="header-icon">
                    <i [ngClass]="panelIconClass"></i>
                </div>
            }
            <h3>{{ panelTitle }}</h3>
        </div>
        <div class="float-end header-button-container">
            @if (supportsMultipleViews && view === 'DISPLAY') {
                <button
                    title="Edit"
                    type="button"
                    class="ace-btn btn-text btn-sm has-icon btn-primary"
                    (click)="edit()">
                    <i class="fa fa-pencil fa-align"></i>
                </button>
            }
            @if (view === 'EDIT') {
                <button
                    title="Save"
                    type="button"
                    class="ace-btn has-icon btn-primary"
                    (click)="save()">
                    <i class="fa fa-save fa-align"></i>
                </button>
            }
            @if (view === 'EDIT') {
                <button
                    title="Cancel"
                    type="button"
                    class="ace-btn has-icon btn-primary"
                    (click)="cancel()">
                    <i class="fa fa-times fa-align"></i>
                </button>
            }
            @if (canExpand && !isExpanded) {
                <button
                    title="Expand"
                    type="button"
                    class="ace-btn has-icon btn-primary"
                    (click)="toggleIsExpanded()">
                    <i class="fa fa-plus fa-align"></i>
                </button>
            }
            @if (canCollapse && isExpanded) {
                <button
                    title="Collapse"
                    type="button"
                    class="ace-btn has-icon btn-primary"
                    (click)="toggleIsExpanded()">
                    <i class="fa fa-minus fa-align"></i>
                </button>
            }
        </div>
    </div>
    @if (isExpanded) {
        <div class="card-body">
            @if (view === 'DISPLAY') {
                <ng-content select="[display-view]"></ng-content>
            }
            @if (view === 'EDIT') {
                <ng-content select="[edit-view]"></ng-content>
            }
        </div>
    }
    <!-- TODO: Add footer functionality if necessary. Consider differentiating between 'EDIT' and 'DISPLAY' footers. -->
    <!-- <div class="panel-footer" *ngIf="isExpanded">footers</div> -->
</div>
